export const getSurvey = (state) => state.survey.data;

export const getSurveyPending = (state) => state.survey.pending;

export const getAssignedToSurvey = (state) => state.survey.assignedContacts;

export const getPurchaserProfiles = (state) => state.survey.purchaserProfiles;

export const getPurchaserProfile = (state) => state.survey.purchaserProfile;
